module.exports = __webpack_public_path__ + "img/6.b702df02.png";